// extracted by mini-css-extract-plugin
module.exports = {"lineHeader":"TotalLine_lineHeader__3u22A","line":"TotalLine_line__3jcxN","plan":"TotalLine_plan__2Ju_O","cell":"TotalLine_cell__1xLSM","title":"TotalLine_title__3lDyF"};